/**
 * Solicitudes section for CreateSolicitudDialog
 */
import React from 'react';
import { Button } from '../ui/button';
import { Plus } from 'lucide-react';
import SolicitudItem from './SolicitudItem';

const SolicitudesSection = ({
  solicitudes,
  onAdd,
  onRemove,
  onUpdate,
  onUpdateFotos,
  // Catálogos
  categorias = [],
  lugares = [],
  items = [],
  fallas = []
}) => {
  return (
    <div className="border border-[#E8E8E7] rounded-lg p-3 sm:p-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mb-3">
        <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-[#2D2D2D]" style={{ fontFamily: 'Playfair Display, serif' }}>
          Solicitudes ({solicitudes.length})
        </h3>
        <Button
          type="button"
          onClick={onAdd}
          variant="outline"
          size="sm"
          className="border-[#9d8272] text-[#9d8272] hover:bg-[#9d8272] hover:text-white text-xs sm:text-sm"
          data-testid="add-solicitud-btn"
        >
          <Plus size={14} className="mr-1" />
          Agregar
        </Button>
      </div>

      <div className="space-y-3 sm:space-y-4">
        {solicitudes.map((sol, index) => (
          <SolicitudItem
            key={index}
            solicitud={sol}
            index={index}
            canDelete={solicitudes.length > 1}
            onUpdate={onUpdate}
            onUpdateFotos={onUpdateFotos}
            onRemove={onRemove}
            categorias={categorias}
            lugares={lugares}
            items={items}
            fallas={fallas}
          />
        ))}
      </div>
    </div>
  );
};

export default SolicitudesSection;
